import { DateTime } from "luxon";

export const formatCreatedAt = (createdAt?: string): string => {
  if (createdAt) {
    return DateTime.fromISO(createdAt).toLocaleString({ month: "short", day: "numeric", year: "numeric" });
  } else {
    return "";
  }
};
